var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3617 8.26319C14.3617 7.75229 14.0507 7.2917 13.5736 7.09619C13.0966 6.90068 12.5475 7.00875 12.1824 7.37001L5.37712 14.1036C5.36665 14.1139 5.35636 14.1244 5.34625 14.135C5.13154 14.361 5 14.6653 5 15C5 15.1699 5.0339 15.332 5.09538 15.48C5.15769 15.6303 5.25054 15.7711 5.37391 15.8932L12.1824 22.63C12.5475 22.9913 13.0966 23.0993 13.5736 22.9038C14.0507 22.7083 14.3617 22.2477 14.3617 21.7368V16.2631H23.7234C24.4284 16.2631 25 15.6976 25 15C25 14.3024 24.4284 13.7368 23.7234 13.7368H14.3617V8.26319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.120560362cf1133fc73f69474f711591.svg";
export { ForwardRef as ReactComponent };